import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Button, Tooltip } from 'antd';
import { QuestionCircleOutlined, GiftOutlined } from '@ant-design/icons';

import { FormattedMessage } from '../../../../util/reactIntl';
import { ACCOUNT_SETTINGS_PAGES } from '../../../../routing/routeConfiguration';
import {
  Avatar,
  InlineTextButton,
  LinkedLogo,
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
  NamedLink,
} from '../../../../components';

import heroImg from '../../../../assets/hero-img.png';

import TopbarSearchForm from '../TopbarSearchForm/TopbarSearchForm';
import CustomLinksMenu from './CustomLinksMenu/CustomLinksMenu';

import css from './TopbarDesktop.module.css';
import { useParams } from 'react-router-dom';
import { userTypeOf } from '../../../../util/userType';
import { teamRoleOf } from '../../../../util/teamRole';

// Home-page CTA for logged-out, first-time visitors. Routes to signup with a
// `freeTrial` marker passed via router state (not a query param — the query string
// is consumed wholesale as an invite link in AuthenticationPage). AuthenticationPage
// stashes the intent in localStorage so it survives the signup → email-confirm →
// onboarding hops; on onboarding completion the user is sent to the subscriptions
// page — collapsing the long login → navigate → start-trial path.
const FreeTrialLink = () => {
  return (
    <NamedLink
      name="SignupPage"
      to={{ state: { freeTrial: true } }}
      className={css.freeTrialLink}
    >
      <GiftOutlined className={css.freeTrialIcon} />
      <span className={css.freeTrialLabel}>
        <FormattedMessage id="TopbarDesktop.freeTrial" />
      </span>
    </NamedLink>
  );
};

const SignupLink = () => {
  return (
    <NamedLink name="SignupPage" className={css.topbarLink}>
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.signup" />
      </span>
    </NamedLink>
  );
};

const LoginLink = () => {
  return (
    <NamedLink name="LoginPage" className={css.topbarLink}>
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.login" />
      </span>
    </NamedLink>
  );
};

const InboxLink = ({ notificationCount, currentUserHasListings }) => {
  const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;
  return (
    <>
      {/* <NamedLink
        className={css.topbarLink}
        name="InboxPage"
        params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
      >
      <Tooltip title="Messages">
        <Button color="default" variant="text" size='large' shape="circle" icon={<MailOutlined style={{ fontSize: 20 }} />} />
      </Tooltip>
      </NamedLink> */}
    </>
  );
};

const ProfileMenu = ({ currentPage, currentUser, onLogout, isOnboardingForm, tab, profileListing }) => {
  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };

  const isCandidate = userTypeOf(currentUser) === 'candidate';
  const isCustomer = userTypeOf(currentUser) === 'customer';
  const customerType = currentUser?.attributes?.profile?.publicData?.customerProfile?.customerType || profileListing?.attributes?.publicData?.customerProfile?.customerType || null;

  if(isOnboardingForm) {
    return (
      <Menu>
        <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
          {currentUser?.profileImage ? (
            <Avatar className={css.avatar} user={currentUser} disableProfileLink />
            ) : (
            // <Avatar className={css.avatar} size={64}>
            //   <span className={css.avatarText}>{currentUser?.attributes?.profile?.displayName ? currentUser?.attributes?.profile?.displayName?.charAt(0).toUpperCase() : '?'}</span>
            // </Avatar>
            <span className={css.avatarText}>{currentUser?.attributes?.profile?.displayName ? (currentUser?.attributes?.profile?.displayName?.charAt(0).toUpperCase() + currentUser?.attributes?.profile?.lastName?.charAt(0).toUpperCase()) : '?'}</span>
          )}
        </MenuLabel>
        
        <MenuContent className={css.profileMenuContent}>
          <MenuItem key="ProfileSettingsPage">
            <NamedLink
              className={classNames(css.menuLink, currentPageClass('ProfileSettingsPage'))}
              name="ProfileSettingsPage"
            >
              <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
            </NamedLink>
          </MenuItem>
          <MenuItem key="SupportPage">
            <NamedLink
              className={classNames(css.menuLink, currentPageClass('AccountSettingsPage'))}
              name="SupportPage"
            >
              Support
            </NamedLink>
          </MenuItem>
          <MenuItem key="logout">
            <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
              <FormattedMessage id="TopbarDesktop.logout" />
            </InlineTextButton>
          </MenuItem>
        </MenuContent>
      </Menu>
    );
  }

  return (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        {currentUser?.profileImage ? (
          <Avatar className={css.avatar} user={currentUser} disableProfileLink />
          ) : (
          // <Avatar className={css.avatar} size={64}>
          //   <span className={css.avatarText}>{currentUser?.attributes?.profile?.displayName ? currentUser?.attributes?.profile?.displayName?.charAt(0).toUpperCase() : '?'}</span>
          // </Avatar>
          <span className={css.avatarText}>{currentUser?.attributes?.profile?.displayName ? (currentUser?.attributes?.profile?.displayName?.charAt(0).toUpperCase() + currentUser?.attributes?.profile?.lastName?.charAt(0).toUpperCase()) : '?'}</span>
        )}
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        <MenuItem key="" className={css.profileMenuName}>
        {currentUser?.profileImage ? (
          <Avatar className={css.avatar} user={currentUser} disableProfileLink />
          ) : (
          // <Avatar className={css.avatar} size={64}>
          //   <span className={css.avatarText}>{currentUser?.attributes?.profile?.displayName ? currentUser?.attributes?.profile?.displayName?.charAt(0).toUpperCase() : '?'}</span>
          // </Avatar>
          <span className={css.avatarText}>{currentUser?.attributes?.profile?.displayName ? (currentUser?.attributes?.profile?.displayName?.charAt(0).toUpperCase() + currentUser?.attributes?.profile?.lastName?.charAt(0).toUpperCase()) : '?'}</span>
        )}
        <span>{currentUser?.attributes?.profile?.displayName}</span>
        </MenuItem>
        <MenuItem key="DashboardPage">
          {/* {!isCandidate && */}
            <NamedLink
              className={classNames(css.menuLink, currentPageClass('DashboardPage'))}
              name="DashboardPage"
            >
              Dashboard
            </NamedLink>
          {/* } */}
        </MenuItem>
        <MenuItem key="WalletPage">
          {/* {!isCandidate && */}
          {/* {(currentUser?.attributes?.profile?.publicData?.role !== 'HR/Talent Acquisition') && */}
          {(teamRoleOf(currentUser) === 'Admin' || isCandidate) &&
            <NamedLink
              className={classNames(css.menuLink, currentPageClass('WalletPage'))}
              name="WalletPage"
            >
              iParley Wallet
            </NamedLink>
          }
          {/* } */}
        </MenuItem>

        <MenuItem key="UserManagementPage">
          {(!isCandidate && teamRoleOf(currentUser) !== 'Tech Sales') &&
            <NamedLink
              className={classNames(css.menuLink, currentPageClass('UserManagementPage'))}
              name="UserManagementPage"
            >
              Manage Users
            </NamedLink>
          }
        </MenuItem>

        <MenuItem key="RFPPostsPage">
          {isCustomer && customerType?.toLowerCase().includes('implementation') && (teamRoleOf(currentUser) === 'Admin' || teamRoleOf(currentUser) === 'Tech Acquisition' || teamRoleOf(currentUser) === 'Tech Manager') &&
            <NamedLink
              className={classNames(css.menuLink, currentPageClass('ManageListingsPage'))}
              name="RFPPostsPage" 
              params={{ tab: 'rfp-dashboard' }}
            >
              <FormattedMessage id="TopbarDesktop.rfpPostsLink" />
              {/* <FormattedMessage id="TopbarDesktop.yourListingsLink" /> */}
            </NamedLink>
          }
        </MenuItem>
        <MenuItem key="JobPostsPage">
          {isCustomer && customerType?.toLowerCase().includes('staffing') && (teamRoleOf(currentUser) === 'Admin' || teamRoleOf(currentUser) === 'HR/Talent Acquisition' || teamRoleOf(currentUser) === 'Hiring Manager') &&
            <NamedLink
              className={classNames(css.menuLink, currentPageClass('ManageListingsPage'))}
              name="JobPostsPage" 
              params={{ tab: 'job-dashboard' }}
            >
              <FormattedMessage id="TopbarDesktop.jobPostsLink" />
              {/* <FormattedMessage id="TopbarDesktop.yourListingsLink" /> */}
            </NamedLink>
          }
        </MenuItem>
        <MenuItem key="ProfileSettingsPage">
          <NamedLink
            className={classNames(css.menuLink, currentPageClass('ProfileSettingsPage'))}
            name="ProfileSettingsPage"
          >
            {/* <FormattedMessage id="TopbarDesktop.profileSettingsLink" /> */}
            Profile
          </NamedLink>
        </MenuItem>
        <MenuItem key="AccountSettingsPage">
          <NamedLink
            className={classNames(css.menuLink, currentPageClass('AccountSettingsPage'))}
            name="AccountSettingsPage"
          >
            <FormattedMessage id="TopbarDesktop.accountSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="SupportPage">
          <NamedLink
            className={classNames(css.menuLink, currentPageClass('AccountSettingsPage'))}
            name="SupportPage"
          >
            Support
          </NamedLink>
        </MenuItem>
        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <FormattedMessage id="TopbarDesktop.logout" />
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  );
};

/**
 * Topbar for desktop layout
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean} props.currentUserHasListings
 * @param {CurrentUser} props.currentUser API entity
 * @param {string?} props.currentPage
 * @param {boolean} props.isAuthenticated
 * @param {number} props.notificationCount
 * @param {Function} props.onLogout
 * @param {Function} props.onSearchSubmit
 * @param {Object?} props.initialSearchFormValues
 * @param {Object} props.intl
 * @param {Object} props.config
 * @param {boolean} props.showSearchForm
 * @returns {JSX.Element} search icon
 */
const TopbarDesktop = props => {
  const {
    className,
    config,
    customLinks,
    currentUser,
    currentPage,
    rootClassName,
    currentUserHasListings,
    notificationCount = 0,
    intl,
    isAuthenticated,
    onLogout,
    onSearchSubmit,
    initialSearchFormValues = {},
    showSearchForm,
    isOnboardingForm = false,
    linkNotifications,
    onUpdateLinkedConsultant,
    onMarkLinkSeen,
    profileAccessRequests,
    onApproveAccessRequest,
    onRejectAccessRequest,
    integrityCompletionNotifications,
    onMarkIntegrityCompletionNotificationSeen,
    onMarkEmployerAnswerSeen,
    notices,
    onMarkNoticeSeen,
    history,
    routeConfiguration,
    profileListing,
  } = props;
  const [mounted, setMounted] = useState(false);

  const isCandidate = userTypeOf(currentUser) === 'candidate';

  const params = useParams();
  const { tab } = params;

  useEffect(() => {
    setMounted(true);
  }, []);

  const marketplaceName = config.marketplaceName;
  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;

  const giveSpaceForSearch = customLinks == null || customLinks?.length === 0;
  const classes = classNames(rootClassName || css.root, className);

  const inboxLinkMaybe = authenticatedOnClientSide ? (
    <InboxLink
      notificationCount={notificationCount}
      currentUserHasListings={currentUserHasListings}
    />
  ) : null;

  const profileMenuMaybe = authenticatedOnClientSide ? (
    <ProfileMenu currentPage={currentPage} currentUser={currentUser} onLogout={onLogout} isOnboardingForm={isOnboardingForm} tab={tab} profileListing={profileListing} />
  ) : null;

  const freeTrialLinkMaybe = isAuthenticatedOrJustHydrated ? null : <FreeTrialLink />;
  const signupLinkMaybe = isAuthenticatedOrJustHydrated ? null : <SignupLink />;
  const loginLinkMaybe = isAuthenticatedOrJustHydrated ? null : <LoginLink />;

  const searchFormMaybe = showSearchForm ? (
    <TopbarSearchForm
      className={classNames(css.searchLink, { [css.takeAvailableSpace]: giveSpaceForSearch })}
      desktopInputRoot={css.topbarSearchWithLeftPadding}
      onSubmit={onSearchSubmit}
      initialValues={initialSearchFormValues}
      appConfig={config}
      currentUser={currentUser}
      profileListing={profileListing}
    />
  ) : (
    <div
      className={classNames(css.spacer, css.topbarSearchWithLeftPadding, {
        [css.takeAvailableSpace]: giveSpaceForSearch,
      })}
    />
  );

  return (
    <nav className={classes}>
      <LinkedLogo
        className={css.logoLink}
        layout="desktop"
        alt={intl.formatMessage({ id: 'TopbarDesktop.logo' }, { marketplaceName })}
        linkToExternalSite={config?.topbar?.logoLink}
        currentUser={currentUser}
      />
      {searchFormMaybe}

      {!isOnboardingForm &&
        <CustomLinksMenu
          currentPage={currentPage}
          customLinks={customLinks}
          intl={intl}
          hasClientSideContentReady={authenticatedOnClientSide || !isAuthenticatedOrJustHydrated}
          currentUser={currentUser}
          currentUserNotificationCount={notificationCount}
          linkNotifications={linkNotifications}
          onUpdateLinkedConsultant={onUpdateLinkedConsultant}
          onMarkLinkSeen={onMarkLinkSeen}
          profileAccessRequests={profileAccessRequests}
          onApproveAccessRequest={onApproveAccessRequest}
          onRejectAccessRequest={onRejectAccessRequest}
          integrityCompletionNotifications={integrityCompletionNotifications}
          onMarkIntegrityCompletionNotificationSeen={onMarkIntegrityCompletionNotificationSeen}
          onMarkEmployerAnswerSeen={onMarkEmployerAnswerSeen}
          notices={notices}
          onMarkNoticeSeen={onMarkNoticeSeen}
          history={history}
          routeConfiguration={routeConfiguration}
        />
      }
      
      {!isOnboardingForm ? (
          <>
            {inboxLinkMaybe}
            {profileMenuMaybe}
            {!isAuthenticatedOrJustHydrated && (
              <div style={{ display: 'flex', alignItems: 'center', height: '100%', padding: '10px' }}>
                <Tooltip title="Help Center">
                  <a href="https://help.iparley.com" target="_blank" rel="noopener noreferrer" style={{ lineHeight: 0 }}>
                    <Button color="default" variant="text" size="large" shape="circle" icon={<QuestionCircleOutlined style={{ color: 'var(--marketplaceColor)', fontSize: '20px' }} />} />
                  </a>
                </Tooltip>
              </div>
            )}
            {freeTrialLinkMaybe}
            {signupLinkMaybe}
            {loginLinkMaybe}
          </>
        ) : (
          <>
            {profileMenuMaybe}
          </>
        )}

      
    </nav>
  );
};

export default TopbarDesktop;
